const onImageRescaling = (imageUrl, width) => {
  return imageUrl.replace("/upload", `/upload/w_${width},c_scale`);
};

export default onImageRescaling;
